export interface IGeneralSettingsState {
  hiddenRaceCountries: any[];
  showTopWinnings: boolean;
  chat: {
    enabled: boolean;
  };
  // Runtime kill switch for the virtuals lobby (backend setting
  // system/virtualsEnabled). Optional: older backends omit it, and the
  // consumers read SettingsService.virtualsEnabled$ rather than this slice.
  virtualsEnabled?: boolean;
}

export const initialGeneralSettingsState: IGeneralSettingsState = {
  hiddenRaceCountries: [],
  showTopWinnings: false,
  chat: {
    enabled: false,
  },
};
